import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ProductInventory extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) {
      this.style.display = 'none';
      return;
    }

    this.style.display = '';
    this.innerHTML = newInventory.innerHTML;
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
